import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import StudentreportComp from './StudentreportComp'

function Studentsreposts() {
  return (
    <div className='mainContainer'>
        <LeftmenuIn/>
        <div className='theMainContainer'>
        <DashnavIn/>
        <StudentreportComp/>
        
        </div>
    </div> 
  )
}

export default Studentsreposts